import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import Card from '../../controls/Card'
import { useToast } from '../../controls/Toast/ToastService';
import {
    MdErrorOutline,
    MdOutlineLocationOn,
    MdOutlineMonitor,
    MdOutlineSupportAgent,
    MdRefresh,
    MdAdd,
    MdOutlineAccessTime,
} from 'react-icons/md';
import { FaUserDoctor } from 'react-icons/fa6';
import { FaClinicMedical } from 'react-icons/fa';
import { GetAllByUserPublic } from '../../../configurations/crud/opdCentersCrud';
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo';
import StatusContainer from '../../controls/StatusContainer';
import { EDoctorStatusBg, GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus';
import { Link, useParams } from 'react-router-dom';
import LoadingContainer from '../../controls/LoadingContainer';
import Empty from '../../controls/Empty';
import useGlobalLoader from '../../../configurations/useGlobalLoader';

export default function StartOPD() {
    const { start, end } = useGlobalLoader()
    const [opdCenters, setOpdCenter] = useState([]);
    const [loding, setLoding] = useState(false);
    const toast = useToast();
    const loginInfo = getLoginInfo()


    useEffect(() => {
        getAllOpdCenters()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getAllOpdCenters() {
        setLoding(true);
        start()
        GetAllByUserPublic({ DoctorId: loginInfo.doctorId })
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    setOpdCenter(mdata.data);
                } else {
                    setOpdCenter([]);
                    //toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch((errors) => {
                setOpdCenter([]);
                //toast.open(errors, <MdErrorOutline />, "danger");
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    }

    return (
        <Container>
            <div className="flex w-full justify-center px-2 py-4 sm:px-4">
                <div className="w-full lg:w-10/12 xl:w-8/12">

                    {/* toolbar */}
                    <div className="mb-4 flex items-center justify-between gap-2">
                        <div className="flex items-center gap-2">
                            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-brand-500 text-white shadow-sm">
                                <FaClinicMedical className="text-base" />
                            </span>
                            <div className="leading-tight">
                                <h2 className="text-base font-semibold text-gray-800">Start OPD</h2>
                                <p className="text-xs text-gray-500">
                                    {loding ? "Loading..." : `${opdCenters.length} center${opdCenters.length == 1 ? "" : "s"} available`}
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={getAllOpdCenters}
                            title="Refresh"
                            className="grid h-9 w-9 shrink-0 place-items-center rounded-xl border border-gray-200 bg-white text-gray-500 shadow-sm transition hover:bg-gray-50 hover:text-gray-700 active:scale-95"
                        >
                            <MdRefresh className="text-xl" />
                            <span className="sr-only">Refresh</span>
                        </button>
                    </div>

                    {!loding ? (
                        opdCenters.length > 0 ? (
                            <div className="grid w-full grid-cols-1 gap-4 sm:gap-6 md:grid-cols-2">
                                {opdCenters.map((item, index) => (
                                    <Card key={item.id ?? index} isBorder={true}>
                                        <div className="flex flex-col gap-4 p-1 sm:p-2">

                                            {/* center info */}
                                            <div className="flex flex-col items-center text-center">
                                                <span className="mb-2 grid h-11 w-11 place-items-center rounded-2xl bg-brand-50 text-brand-500 ring-1 ring-brand-100">
                                                    <FaClinicMedical className="text-lg" />
                                                </span>
                                                <h3 className="text-xl font-bold text-gray-900">{item.centerName}</h3>
                                                <p className="mt-1 inline-flex items-center gap-1 text-sm text-gray-500">
                                                    <MdOutlineLocationOn className="shrink-0 text-blue-500" />
                                                    {item.address}
                                                </p>
                                                <div className="mt-3 inline-flex items-center gap-2 text-sm">
                                                    <span className="inline-flex items-center gap-1 text-gray-400">
                                                        <FaUserDoctor className="text-xs" /> Doctor's Status
                                                    </span>
                                                    <StatusContainer bg={EDoctorStatusBg(item.doctorStatus)} text={GetEDoctorStatusName(item.doctorStatus)} />
                                                </div>
                                            </div>

                                            {/* actions */}
                                            <div className="grid grid-cols-3 gap-2">
                                                <Link
                                                    to={"/doctor/" + item.id + "/center"}
                                                    className="flex flex-col items-center justify-center gap-1.5 rounded-xl bg-green-500 p-3 text-white shadow-sm transition hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 active:scale-95 sm:p-4"
                                                >
                                                    <FaUserDoctor className="text-xl" />
                                                    <span className="text-xs font-semibold sm:text-sm">Doctor</span>
                                                </Link>
                                                <Link
                                                    to={"/display/" + item.id + "/center"}
                                                    className="flex flex-col items-center justify-center gap-1.5 rounded-xl bg-slate-500 p-3 text-white shadow-sm transition hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-slate-400 active:scale-95 sm:p-4"
                                                >
                                                    <MdOutlineMonitor className="text-xl" />
                                                    <span className="text-xs font-semibold sm:text-sm">Display</span>
                                                </Link>
                                                <Link
                                                    to={"/reception/" + item.id + "/center"}
                                                    className="flex flex-col items-center justify-center gap-1.5 rounded-xl bg-blue-500 p-3 text-white shadow-sm transition hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 active:scale-95 sm:p-4"
                                                >
                                                    <MdOutlineSupportAgent className="text-xl" />
                                                    <span className="text-xs font-semibold sm:text-sm">Reception</span>
                                                </Link>
                                            </div>
                                        </div>
                                    </Card>
                                ))}
                            </div>
                        ) : (
                            /* empty state */
                            <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-gray-300 bg-gray-50 px-4 py-12 text-center">
                                <span className="grid h-12 w-12 place-items-center rounded-full bg-white text-gray-400 shadow-sm">
                                    <FaClinicMedical className="text-xl" />
                                </span>
                                <p className="text-sm font-medium text-gray-600">No OPD Centers Created.</p>
                                <p className="text-xs text-gray-400">Create a center first, then you can start OPD from here.</p>
                                <Link
                                    to="/opdcenters/add"
                                    className="mt-2 inline-flex items-center gap-1.5 rounded-xl bg-brand-500 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-brand-600 active:scale-95"
                                >
                                    <MdAdd className="text-lg" /> Add Center
                                </Link>
                            </div>
                        )
                    ) : (
                        <div className="w-full">
                            <LoadingContainer text={"Getting centers to start OPD"} />
                        </div>
                    )}
                </div>
            </div>
        </Container>
    )
}